import { Theme } from "@mui/material";
import { isString } from "es-toolkit";
import { CSSProperties } from "react";

export type ColorType = NonNullable<CSSProperties["color"]>;
export type ColorProp = ColorType | ((theme: Theme) => ColorType);

/**
 * Calculates ripple color with opacity
 * Handles both string colors (from palette or hex) and function colors
 * Applies 15% opacity (26 in hex)
 */
export function getRippleColorWithOpacity(
  rippleColor: ColorProp | undefined,
  theme: Theme
): ColorType | undefined {
  if (!rippleColor) {
    return undefined;
  }

  let color;

  // If the rippleColor prop is a function, use the theme to retrieve the color
  if (typeof rippleColor === "function") {
    color = rippleColor(theme);
  } else if (isString(rippleColor)) {
    // Check if the rippleColor is present in the theme's palette and take it from there if available
    const colorEntry = Object.entries(theme.palette).find(
      (entry) => entry[0] === rippleColor
    );
    if (colorEntry) {
      color = colorEntry[1];
    }
  }

  // rippleColor was not part of the theme but it could still be valid
  // Using 26 for 15% opacity
  return `${color ?? rippleColor}26`;
}
